<template>
  <hi-data-list-kit
    :search-fn="projectListSearchFn"
    :sortables="projectSortRules"
    :filter-value="filterOwner"
    filter-key="mainOwner"
    @select="onSelect"
    search-input-placeholder="Name, Address or Type"
    :current-id="projectsState.currentProjectId"
  >
    <template v-slot:filterArea>
      <hi-select
        placeholder="Main Owner..."
        v-model="filterOwner"
        :items="userNoMaintenance"
        no-form
      />
    </template>
    <template v-slot="{ item }">
      <project-summary :project-data="item" />
    </template>
  </hi-data-list-kit>
</template>

<script>
import {
  projectListSearchFn,
  projectSortRules,
  provideLoseProjectsListStore,
} from "@/hive-vue3/modules/projects/data";
import ProjectSummary from "@/hive-vue3/modules/projects/ProjectSummary";
import { projectsState } from "@/hive-vue3/modules/projects/state";
import HiDataListKit from "@/hive-vue3/components/dataDisplay/HiDataListKit";
import HiSelect from "@/hive-vue3/components/form/controls/HiSelect";
import { computed, ref } from "vue";
import { useSystemUsers } from "@/hive-vue3/firebase";
export default {
  name: "ProjectsLoseList",
  components: { HiSelect, HiDataListKit, ProjectSummary },
  setup() {
    provideLoseProjectsListStore();

    function onSelect(item) {
      projectsState.currentProjectId = item.id;
    }

    const filterOwner = ref(undefined);
    const users = useSystemUsers();
    const userNoMaintenance = computed(() => {
      const returnArr = [{ text: "NAN", value: "noFilter" }];
      for (const i in users) {
        if (users[i].roles.indexOf("maintenance") === -1) {
          returnArr.push({
            text: users[i].name,
            value: users[i].id,
          });
        }
      }
      return returnArr;
    });

    return {
      onSelect,
      projectListSearchFn,
      projectSortRules,
      projectsState,
      userNoMaintenance,
      filterOwner,
    };
  },
};
</script>

<style scoped></style>
